// @flow

import type { SearchNotificationsState } from './types';

const searchNotifications: SearchNotificationsState = [];

export default searchNotifications;



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/initialState.js